import React from 'react'
import {BrowserRouter} from 'react-router-dom'
import Router from '../routes/Router'
import Init from './Init'
import 'bootstrap/dist/css/bootstrap.min.css'
import '../stylesheets/App.scss'

const App = () => {
  return (
    <BrowserRouter>
      <Init />
      <Router/>
    </BrowserRouter>
  )
}

export default App
